
import { Vue, Component, Prop } from 'vue-property-decorator'
import AvatarBasic from '~/components/common/AvatarBasic.vue'

@Component({
  name: 'ApplicationReviewHeader',
  components: {
    AvatarBasic
  }
})

export default class ApplicationReviewHeader extends Vue {
  @Prop({ default: '' }) title!: string
}
